import React from 'react';
import stringHelper from '../../../Helpers/stringHelper';

export default class TextField2 extends React.Component {
  static defaultProps = {
    className: 'w-100 form-control form-control-sm',
    fieldName: 'defaultFieldname',
    onChange: () => {},
    placeholder: 'Default Placeholder',
    value: null,
    fieldType: 'text',
    editedItem: {},
  };

  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.props.fieldType === 'Decimal') {
      return (
        <input
          type='number'
          className={this.props.className}
          placeholder='0.00'
          value={this.props.value === null ? '' : stringHelper.removeTrailingZeros(this.props.value)}
          onChange={(e) => {
            let val = e.target.value;
            if (this.props.fieldType === 'number') {
              val = parseInt(val);
              if (Number.isNaN(val)) val = '';
            }
            this.props.onChange(this.props.fieldName, val);
          }}
          id={`htmlidfor${this.props.fieldName}`}
          readOnly={false}
          autoComplete='off'
          step='0.01'
        />
      );
    }
    const ph =
      typeof this.props.placeholder === 'function'
        ? this.props.placeholder(this.props.editedItem)
        : this.props.placeholder;
    return (
      <input
        type={this.props.fieldType}
        className={this.props.className === '' ? 'inputFigma' : this.props.className}
        placeholder={ph}
        value={this.props.value === null ? '' : this.props.value}
        onChange={(e) => {
          let val = e.target.value;
          if (this.props.fieldType === 'number') {
            val = parseInt(val);
            if (Number.isNaN(val)) val = '';
          }
          this.props.onChange(this.props.fieldName, val);
        }}
        id={`htmlidfor${this.props.fieldName}`}
        readOnly={false}
        autoComplete='off'
      />
    );
  }
}
